import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css'; // import first
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { registerApiErrorHandling } from './utils/apiErrors';
import App from './App';
import { reportWebVitals } from './reportWebVitals';
import './index.scss';

import { store } from './app/store';

registerApiErrorHandling(axios);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <ToastContainer />
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
